import { render, staticRenderFns } from "./AdjustmentItem.vue?vue&type=template&id=050d1cfd"
import script from "./AdjustmentItem.vue?vue&type=script&lang=js"
export * from "./AdjustmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports